import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\StoreDocumentController::__invoke
* @see app/Http/Controllers/Document/StoreDocumentController.php
* @route '/api/document'
*/
const StoreDocumentController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StoreDocumentController.url(options),
    method: 'post',
})

StoreDocumentController.definition = {
    methods: ["post"],
    url: '/api/document',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Document\StoreDocumentController::__invoke
* @see app/Http/Controllers/Document/StoreDocumentController.php
* @route '/api/document'
*/
StoreDocumentController.url = (options?: RouteQueryOptions) => {
    return StoreDocumentController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\StoreDocumentController::__invoke
* @see app/Http/Controllers/Document/StoreDocumentController.php
* @route '/api/document'
*/
StoreDocumentController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StoreDocumentController.url(options),
    method: 'post',
})

export default StoreDocumentController